export interface BrandProps {
  id: string;
  name: string;
  slug: string;
  description?: string | null;
  imageId?: string;
  imageUrl?: string | null;
  status?: boolean;
  logoUrl?: string | null;
  websiteUrl?: string | null;
  displayOrder?: number;
  isFeatured?: boolean;
  createdAt?: string;
  updatedAt?: string;
  image?: {
    id: string;
    url: string;
    fileName: string;
    altText?: string | null;
  } | null;
}

export class BrandEntity {
  constructor(private readonly props: BrandProps) {
    if (!props.id) throw new Error('El ID de marca es obligatorio');
    if (!props.name) throw new Error('El nombre de marca es obligatorio');
    if (!props.slug) throw new Error('El slug de marca es obligatorio');
  }

  get id(): string {
    return this.props.id;
  }

  get name(): string {
    return this.props.name;
  }

  get slug(): string {
    return this.props.slug;
  }

  get description(): string | null | undefined {
    return this.props.description;
  }

  get imageId(): string {
    return this.props.imageId || '';
  }

  get imageUrl(): string | null | undefined {
    return this.props.imageUrl || this.props.image?.url || this.props.logoUrl;
  }

  get logoUrl(): string | null | undefined {
    return this.imageUrl;
  }

  get status(): boolean {
    return this.props.status ?? true;
  }

  get isActive(): boolean {
    return this.status;
  }

  get websiteUrl(): string | undefined | null {
    return this.props.websiteUrl;
  }

  get displayOrder(): number {
    return this.props.displayOrder ?? 0;
  }

  get isFeatured(): boolean {
    return this.props.isFeatured ?? this.status;
  }

  get createdAt(): string | undefined {
    return this.props.createdAt;
  }

  get updatedAt(): string | undefined {
    return this.props.updatedAt;
  }

  toJSON(): BrandProps {
    return { ...this.props };
  }
}
